import React, { useState, useMemo } from 'react';
import { Input, Tabs } from 'antd';
import { SearchOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import Faqs from './Faqs';
import {
  general,
  about,
  enrollment,
  submission,
  crmd,
  digitalization,
  faqDataAll,
} from './FaqsData';

import SecLogo from '../../../../../utility/unnamed.png';
import SecBuilding from '../../../../../assets/files/img/aaa.jpg';

export default function FAQHome() {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('all');

  // Filter based on active tab and search term
  const filteredFaqs = useMemo(() => {
    let dataset = faqDataAll;

    if (activeTab === 'general') dataset = general;
    else if (activeTab === 'about') dataset = about;
    else if (activeTab === 'enrollment') dataset = enrollment;
    else if (activeTab === 'submission') dataset = submission;
    else if (activeTab === 'crmd') dataset = crmd;
    else if (activeTab === 'digitalization') dataset = digitalization;

    if (!searchTerm.trim()) return dataset;

    const term = searchTerm.toLowerCase();
    return dataset.filter(
      (item) =>
        item.question.toLowerCase().includes(term) ||
        item.answer.toLowerCase().includes(term)
    );
  }, [searchTerm, activeTab]);

  const tabItems = [
    { key: 'all', label: `All FAQs (${faqDataAll.length})` },
    { key: 'general', label: 'General' },
    { key: 'about', label: 'About eFAST' },
    { key: 'enrollment', label: 'Enrollment' },
    { key: 'submission', label: 'Submission' },
    { key: 'crmd', label: 'CRMD' },
    { key: 'digitalization', label: 'Digitalization' },
  ];

  return (
    <div className="relative min-h-screen overflow-x-hidden">
      {/* ── Background Image ── */}
      <img
        src={SecBuilding}
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />

      {/* ── Dark Gradient Overlay ── */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(100deg, rgba(0,36,22,0.93) 0%, rgba(0,50,32,0.82) 45%, rgba(0,30,18,0.65) 100%)',
        }}
      />

      {/* ── Main Canvas Layer ── */}
      <div
        style={{
          position: 'relative',
          zIndex: 10,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {/* Centered Content Wrapper */}
        <div className="flex-1 flex flex-col items-center justify-center p-4 sm:p-8 md:p-12">
          
          {/* Centered Card */}
          <div
            className="w-full max-w-4xl bg-white rounded-[20px] p-6 sm:p-10 my-auto"
            style={{ boxShadow: '0 24px 80px rgba(0,0,0,0.35)' }}
          >
            {/* Header / Branding */}
            <header className="flex flex-col items-center text-center mb-6 pb-6 border-b border-gray-100">
              <img
                src={SecLogo}
                alt="SEC Logo"
                style={{ height: 60, width: 'auto', marginBottom: 12 }}
              />
              <h1 className="text-xl md:text-2xl font-extrabold text-[#111827] mb-1">
                Frequently Asked Questions
              </h1>
              <p className="text-xs sm:text-sm text-gray-500 mb-2">
                Find answers to common questions about eFAST enrollment and submission.
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: '0.08em',
                    padding: '2px 10px',
                    borderRadius: 999,
                    background: 'rgba(15,130,105,0.1)',
                    color: '#0f8269',
                    border: '1px solid rgba(15,130,105,0.2)',
                  }}
                >
                  HELP CENTER
                </span>
              </div>
            </header>

            {/* Search Input */}
            <div className="mb-6">
              <Input
                size="large"
                placeholder="Search keywords or questions..."
                prefix={<SearchOutlined style={{ color: '#0f8269', marginRight: 6 }} />}
                allowClear
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ borderRadius: 12, height: 48 }}
              />
            </div>

            {/* Category Tabs */}
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={tabItems}
              className="mb-4"
            />

            {/* Accordion Content Container */}
            <div className="max-h-[55vh] overflow-y-auto pr-1">
              <Faqs faqData={filteredFaqs} />
            </div>

            {/* Card Footer Actions */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justify: 'space-between',
                width: '100%',
                marginTop: 20,
                paddingTop: 20,
                borderTop: '1px solid #f3f4f6',
              }}
            >
              <Link
                to="/user/login"
                style={{
                  color: '#0f8269',
                  fontWeight: 600,
                  fontSize: 14,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                }}
              >
                <ArrowLeftOutlined /> Back to Sign In
              </Link>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}